import React, { useEffect } from 'react';
import { CertificatesWrapper } from '@components';
import { scrollTop } from '@share/utils';
import styles from './styles.module.scss';

export const CertificatesPage = (): React.ReactElement => {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <div className={styles.root}>
      <CertificatesWrapper />
    </div>
  );
};
